import { Badge, Button, IconButton, ListItemIcon, ListItemText, Menu, MenuItem, Stack, Tooltip } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { BeamerTrigger } from '@omnea-app/fe-app-shell/headers/BeamerTrigger'
import { NotificationInbox } from '@omnea-app/fe-app-shell/headers/NotificationInbox'
import { useHelpActions } from '@omnea-app/fe-app-shell/headers/useHelpActions'
import { useProductUpdates } from '@omnea-app/fe-app-shell/headers/useProductUpdates'
import { useAuthenticatedUser } from '@omnea-app/fe-auth/UserSessionProvider'
import { CopyIdButton } from '@omnea-app/fe-legacy/components/shared/ui/CopyIdButton/CopyIdButton'
import { BookOpenOMIcon, ChatBubbleOMIcon, QuestionCircleOMIcon, SpaceshipOMIcon } from '@omnea-app/icons'
import { useMenu } from '@omnea-app/omui/useMenu'
import { ShellAccount } from './ShellAccount'

/** What the app shell keeps at the right of every top bar: Copy ID, notifications, product updates, Help and the account. */
export const ShellTopBarControls = () => {
  const { org } = useAuthenticatedUser()

  return (
    <>
      <Stack direction="row" alignItems="center" gap={1.5}>
        <CopyIdButton id={org.organisationId} entityType="organisation" />
        <NotificationInbox />
        <ProductUpdatesButton />
        <HelpButton />
      </Stack>
      <ShellAccount />
    </>
  )
}

const ProductUpdatesButton = () => {
  const { t } = useTranslation('common')
  const { isEnabled, hasUnread, show } = useProductUpdates()

  if (!isEnabled) return null

  return (
    <Tooltip title={t('header.product-updates-tooltip')}>
      <IconButton onClick={show}>
        <BeamerTrigger />
        <Badge variant="dot" color="error" overlap="circular" invisible={!hasUnread}>
          <SpaceshipOMIcon />
        </Badge>
      </IconButton>
    </Tooltip>
  )
}

const HelpButton = () => {
  const { t } = useTranslation('common')
  const menu = useMenu()
  const { showLiveSupport, openKnowledgeBase } = useHelpActions()

  return (
    <>
      <Button variant="text" color="secondary" startIcon={<QuestionCircleOMIcon />} onClick={menu.open}>
        {t('header.help')}
      </Button>
      <Menu
        open={menu.isOpen}
        anchorEl={menu.anchorEl}
        onClose={menu.close}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MenuItem
          onClick={() => {
            menu.close()
            showLiveSupport()
          }}
        >
          <ListItemIcon>
            <ChatBubbleOMIcon />
          </ListItemIcon>
          <ListItemText>{t('header.live-support')}</ListItemText>
        </MenuItem>
        <MenuItem
          onClick={() => {
            menu.close()
            openKnowledgeBase()
          }}
        >
          <ListItemIcon>
            <BookOpenOMIcon />
          </ListItemIcon>
          <ListItemText>{t('header.knowledge-base-link')}</ListItemText>
        </MenuItem>
      </Menu>
    </>
  )
}
